// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__314SH","header":"ReportDetails_header__1rNC_","title":"ReportDetails_title__2dsLo","left":"ReportDetails_left__G7C9-"};